import React from 'react';
import Box from '@mui/material/Box';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { isCardPaymentOrder } from '../../utils/utils';

interface OrderPaymentMethodDisplayProps {
  order: { paymentType?: string | null } | null | undefined;
}

export const OrderPaymentMethodDisplay: React.FunctionComponent<
  OrderPaymentMethodDisplayProps
> = ({ order }) => {
  const isCard = isCardPaymentOrder(order ?? {});

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
      {isCard ? (
        <CreditCardIcon fontSize="small" sx={{ color: 'text.secondary' }} />
      ) : (
        <AccountBalanceIcon fontSize="small" sx={{ color: 'text.secondary' }} />
      )}
      <Box component="span" sx={{ fontSize: 14 }}>
        {isCard ? 'Card' : 'ACH'}
      </Box>
    </Box>
  );
};

export default OrderPaymentMethodDisplay;
